import { StyleSheet } from "react-native";

export default StyleSheet.create({
  backBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
  },
  backBox1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "60%",
  },
  pauseBox: {
    width: "80%",
  },
  lowerMainHead: {
    height: 100,
    borderBottomColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  lowerMainHead2: {
    height: 60,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: 20
  },
});
